'use client'

import { useState } from 'react'

import { Spacer } from '@vinted/web-ui'

import { MainFooter } from '@marketplace-web/footer/footer-feature'

import AddVatFormSuccess from './AddVatFormSuccess'
import AddVatFormContent from './AddVatFormContent'

const AddVatPage = () => {
  const [displaySuccess, setDisplaySuccess] = useState(false)

  const handleSucccess = () => {
    setDisplaySuccess(true)
  }

  return (
    <>
      <div className="container small-container">
        <Spacer size={Spacer.Size.X4Large} />
        <div className="u-flexbox u-justify-content-center u-flex-direction-column">
          {displaySuccess ? (
            <AddVatFormSuccess />
          ) : (
            <AddVatFormContent handleSucccess={handleSucccess} />
          )}
        </div>
      </div>
      <Spacer size={Spacer.Size.X6Large} />
      <MainFooter
        isDigitalLawEnabled={false}
        onlineComplaintUrl={undefined}
        isBusinessInfoLinksEnabled
      />
    </>
  )
}

export default AddVatPage
